import { buildModelManager } from "../builder.js";
const DefaultAttendanceEventSelection = {
  __typename: true,
  id: true,
  accuracyMeters: true,
  action: true,
  attestationAccepted: true,
  attestationText: true,
  clientMetadata: true,
  createdAt: true,
  expectedClinicalSiteId: true,
  forwardedIp: true,
  institution: true,
  latitude: true,
  locationFailureReason: true,
  locationPermissionState: true,
  longitude: true,
  matchedClinicalSiteId: true,
  matchedSiteSnapshot: true,
  mode: true,
  nearestSitesSnapshot: true,
  notificationStatus: true,
  occurredAt: true,
  photoEvidence: { url: true, mimeType: true, fileName: true },
  photoMetadata: true,
  requestIp: true,
  shiftDocumentationId: true,
  shiftId: true,
  siteMatchStatus: true,
  updatedAt: true,
  userAgent: true,
  userId: true
};
const modelApiIdentifier = "attendanceEvent";
const pluralModelApiIdentifier = "attendanceEvents";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAttendanceEventSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAttendanceEventSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceEventSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceEventSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceEventSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceEventSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAttendanceEventSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "attendanceEventGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AttendanceEventManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAttendanceEventSelection,
  operations
);
export {
  AttendanceEventManager,
  DefaultAttendanceEventSelection
};
//# sourceMappingURL=AttendanceEvent.js.map
